<div class="laheta-card">
  <div class="autosave-time">{{ autosaveTimeTextObservable | async }}</div>
  <div class="laheta-title light-blue-text">
    Lähetä asiakkaalle sähköposti
    <!-- <button style="margin-left: 20px;" (click)="_resetAutosave()">Poista tietokannasta</button> -->
  </div>
  <div class="laheta-body">
    <form>
      <div style="margin: 0 10px">
        @if (vastaanottajat().length) {
          <div>
            <mat-form-field style="margin-bottom: 15px">
              <mat-label>Vastaanottajat</mat-label>
              <input type="text" [formField]="lomake.vastaanottajat" matInput data-lpignore="true" autocomplete="jokuihantajutonjutthei" />
            </mat-form-field>
          </div>
        } @else {
          <div style="color: #f44336; margin-bottom: 2em; margin-left: 10px">
            <div style="font-weight: bold">Ei vastaanottajia.</div>
            <div style="font-size: 13px">
              (Lisää käyttäjä, jolla on Yhteyshenkilö-rooli, navigoimalla <a [routerLink]="['/asiakkaat', asiakasAvain(), 'kayttajat']">Lemonaid -> Käyttäjät</a>. Varmista, että Aktiivinen-täppä on päällä. Vaihtoehtoisesti voit käyttää yleistä vastaanotto-osoittetta, lisää sellainen
              <a [routerLink]="['/asiakkaat', asiakasAvain(), 'kirjanpitotiedot']">Asetukset -> Kirjanpito -> Kirjanpitosähköpostien lisävastaanottajat</a>)
            </div>
          </div>
        }
        <div style="display: flex; justify-content: space-between; margin-top: -10px; margin-bottom: -10px">
          <mat-form-field style="margin-bottom: 15px; width: 420px">
            <mat-label>Lähettäjä</mat-label>
            <input type="email" [formField]="lomake.lahettaja" matInput data-lpignore="true" autocomplete="jokuihantajutonjutthei" />
          </mat-form-field>
          <mat-checkbox style="margin-top: 10px" [formField]="lomake.piilokopioLahettajalle">Piilokopio lähettäjälle</mat-checkbox>
        </div>
        <mat-form-field style="margin-bottom: 15px">
          <mat-label>Aihe</mat-label>
          <input (blur)="tryAutosave()" [formField]="lomake.aihe" matInput data-lpignore="true" autocomplete="jokuihantajutonjutthei" class="email-aihe" />
          <!-- <button mat-icon-button matSuffix (click)="resetAihe()" title="Palauta alkuperäinen teksti">
        <mat-icon>settings_backup_restore</mat-icon>
      </button> -->
          @if (onkoVirhe(lomake.aihe, 'required') && (lomake.aihe().dirty() || lomake.aihe().touched())) {
            <mat-error> Lisää aihe. </mat-error>
          }
        </mat-form-field>
        <div style="margin: 10px -20px 10px -20px; padding: 20px 20px 0 20px; border: 2px solid rgb(217, 217, 217)">
          <mat-form-field class="no-outline no-margin">
            <textarea #tekstiTextareaAlku (blur)="tryAutosave()" tahtiOhjeeseen [formField]="lomake.tekstinAlku" placeholder="Teksti 1" matInput data-lpignore="true" matInput cdkTextareaAutosize #autosizeAlku="cdkTextareaAutosize" [cdkAutosizeMinRows]="1"></textarea>
            <!-- <button mat-icon-button matSuffix (click)="resetTeksti1()" title="Palauta alkuperäinen teksti">
        <mat-icon>settings_backup_restore</mat-icon>
      </button> -->
            @if (onkoVirhe(lomake.tekstinAlku, 'required') && (lomake.tekstinAlku().dirty() || lomake.tekstinAlku().touched())) {
              <mat-error> Lisää teksti. </mat-error>
            }
          </mat-form-field>
          <div class="autotext">
            <div [style.display]="includeMainAutotext ? 'block' : 'none'">{{ mainAutotext() }}</div>
            <app-button
              (click)="showOrHideMainAutotext()"
              [title]="includeMainAutotext ? 'Poista automaattisesti luotu teksti sähköpostista' : 'Lisää automaattisesti luotu teksti sähköpostiin'"
              actionId="Poista / Lisää automaattisesti luotu pääteksti sähköpostiin (veroilmoitus)"
              styles="position: absolute; top: 0px; right: 0px; margin: 0; line-height: 28px; min-width: 28px; font-size: 24px; padding: 0;"
            >
              {{ includeMainAutotext ? 'x' : '+' }}
            </app-button>
          </div>

          @if (account9940TextObservable | async; as account9940Text) {
            <div class="autotext">
              <div [style.display]="include9940Text() ? 'block' : 'none'" [innerHTML]="account9940Text"></div>
              <app-button (click)="showOrHide9940Box()" [title]="include9940Text() ? 'Poista teksti sähköpostista' : 'Lisää teksti sähköpostiin'" actionId="Poista / Lisää automaattisesti luotu 9940 teksti sähköpostiin " styles="position: absolute; top: 0px; right: 0px; margin: 0; line-height: 28px; min-width: 28px; font-size: 24px; padding: 0;">
                {{ include9940Text() ? 'x' : '+' }}
              </app-button>
            </div>
          }

          <mat-form-field class="no-outline no-margin">
            <textarea #tekstiTextareaLoppu (blur)="tryAutosave()" tahtiOhjeeseen [formField]="lomake.tekstinLoppu" placeholder="Teksti 2" matInput data-lpignore="true" matInput cdkTextareaAutosize #autosizeLoppu="cdkTextareaAutosize" [cdkAutosizeMinRows]="4"></textarea>
            <!-- <button mat-icon-button matSuffix (click)="resetTeksti2()" title="Palauta alkuperäinen teksti">
      <mat-icon>settings_backup_restore</mat-icon>
    </button> -->
            @if (onkoVirhe(lomake.tekstinLoppu, 'required') && (lomake.tekstinLoppu().dirty() || lomake.tekstinLoppu().touched())) {
              <mat-error> Lisää teksti. </mat-error>
            }
          </mat-form-field>
          <div app-kirjanpito-lahetys-signature [kirjanpitajanNimitiedot]="nykyisenKirjanpitajanNimitiedotObservable | async" [kieli]="asiakkaanKieliObservable | async"></div>
        </div>
        Liitteet
        @if (onkoMuuKuinOsakeyhtioObservable | async; as eiOleOsakeyhtio) {
          <div class="check-wrapper">
            @if (eiOleOsakeyhtio.result) {
              <div style="display: flex; flex-direction: row">
                <mat-checkbox class="liitteet-list-item" [formField]="lomake.tuloslaskelma">Tuloslaskelma</mat-checkbox>
                <app-button (click)="downloadTulosPdf()" actionId="Lataa tuloslaskelma koneelle (veroilmoituksen lähetys)" additionalClass="lataa-pdf-button">
                  <i class="fa fa-file-pdf-o"></i>
                </app-button>
              </div>
            }
            @if (eiOleOsakeyhtio.result) {
              <div style="display: flex; flex-direction: row">
                <mat-checkbox class="liitteet-list-item" [formField]="lomake.virallinenTase">Virallinen tase</mat-checkbox>
                <app-button (click)="downloadVirTasePdf()" actionId="Lataa virallinen tase koneelle (veroilmoituksen lähetys)" additionalClass="lataa-pdf-button">
                  <i class="fa fa-file-pdf-o"></i>
                </app-button>
              </div>
            }
            @if (eiOleOsakeyhtio.result) {
              <div style="display: flex; flex-direction: row">
                <mat-checkbox class="liitteet-list-item" [formField]="lomake.virallinenTuloslaskelma">Virallinen tulos</mat-checkbox>
                <app-button (click)="downloadVirTulosPdf()" actionId="Lataa virallinen tulos koneelle (veroilmoituksen lähetys)" additionalClass="lataa-pdf-button">
                  <i class="fa fa-file-pdf-o"></i>
                </app-button>
              </div>
            }
            <div style="display: flex; flex-direction: row">
              <mat-checkbox class="liitteet-list-item" [formField]="lomake.veroilmoitus">Veroilmoitus</mat-checkbox>
              <app-button (click)="downloadVeroilmoitusPdf()" [disabled]="!(voiLahettaaObservable | async)" [matTooltip]="!(voiLahettaaObservable | async) ? pdfEiVoiLadata : ''" actionId="Lataa veroilmoitus koneelle (veroilmoituksen lähetys)" additionalClass="lataa-pdf-button">
                <i class="fa fa-file-pdf-o"></i>
              </app-button>
            </div>
            @if (eiOleOsakeyhtio.result) {
              <div style="display: flex; flex-direction: row">
                <mat-checkbox class="liitteet-list-item" [formField]="lomake.taseErittely">Tase-erittely</mat-checkbox>
                <app-button (click)="downloadTaseErittelyPdf()" [disabled]="lomake.taseErittely().disabled()" actionId="Lataa tase-erittely koneelle (ei oy) (veroilmoituksen lähetys)" additionalClass="lataa-pdf-button">
                  <i class="fa fa-file-pdf-o"></i>
                </app-button>
              </div>
            }
            <!-- <div *ngIf="taseErittely.disabled">
    Tase-erittelyä ei ole tehty. Tee erittely napauttamalla "Tilinpäätös". -->
            <!-- <button mat-button (click)="avaaTaseErittely()" style="text-decoration: underline;">Avaa erittely</button> -->
            <!-- </div> -->
          </div>
        }
        <div class="attachment-wrapper">
          @for (liite of emailLiitteetObservable | async; track liite) {
            <div class="attachment-row">
              <app-icon-button (click)="deleteAttachment(liite)" actionId="Poista liite (veroilmoituksen sähköpostin lähetys)" additionalClass="remove-btn small-icon-button">
                <i class="icon ion-ios-trash icon-btn"></i>
              </app-icon-button>
              <div class="attachment-text">{{ liite.nimi }}</div>
              <div class="attachment-size">{{ liite.koko > 100 * 1000 ? (liite.koko / (1000 * 1000) | ldecimall: 1 : 'fi') : (liite.koko / (1000 * 1000) | ldecimall: 3 : 'fi') }} MT</div>
              <app-icon-button (click)="downloadAttachment(liite)" actionId="Lataa liite koneelle (veroilmoituksen sähköpostin lähetys)" additionalClass="lataa-pdf-button small-icon-button">
                <i class="fa fa-file-pdf-o"></i>
              </app-icon-button>
            </div>
          }
        </div>

        <app-button (click)="fileInput.click()" actionId="Valitse tiedosto: Lisää liitetiedosto (veroilmoituksen sähköpostin lähetys)"> + Lisää liitetiedosto </app-button>
      </div>
    </form>
    @if (attachmentsTotalSizeIfTooBigObservable | async; as totalSize) {
      <div class="error-msg">Sähköpostin liitteiden kokonaiskoko ei saa ylittää 10 MT (Nykyinen koko: {{ totalSize }} MT)</div>
    }
    @if (!(voiLahettaaObservable | async)) {
      <div class="error-msg">Lähetä veroilmoitus ennen asiakassähköpostin lähettämistä</div>
    }
    <div style="display: flex; justify-content: space-evenly; padding-top: 20px">
      <app-primary-button (click)="laheta()" [disabled]="!(voiLahettaaObservable | async) || (attachmentsTotalSizeIfTooBigObservable | async) > 0" actionId="Lähetä veroilmoituksen sähköposti" [actionContext]="[kaytossaOlevatArvot()]"> Lähetä </app-primary-button>
    </div>
  </div>
</div>

<!-- <button mat-button (click)="reload()" type="button">
TYHJENNÄ TÄSTÄ
</button> -->

<div app-veroilmoitus-aikaisemmin-lahetetyt-spostit [perustiedotObservable]="perustiedotObservable" (onkoSpostejaLahetetty)="sahkopostejaOnLahetettyPaivittyi($event)"></div>

<input #fileInput type="file" style="visibility: hidden" accept="*" multiple (change)="lataa($event)" />
